import { type AnyOtherString, type IconName } from "react-better-html";

import { config } from "./betterHtml";

import { type PropertyDealType, type PropertySpaceKind } from "../types/property";

export const dealTypeData: Record<
   PropertyDealType,
   {
      color: string;
   }
> = {
   SALE: {
      color: config.theme?.colors?.light?.info ?? "",
   },
   RENT: {
      color: config.theme?.colors?.light?.info ?? "",
   },
};

export const propertySpaceKindIcon: Record<PropertySpaceKind, IconName | AnyOtherString> = {
   PARKING_SPACE: "parking",
   GARAGE: "garage",
   BALCONY: "balcony",
   LOGGIA: "arch",
   TERRACE: "roof",
   ROOF_TERRACE: "roof",
   YARD: "fence",
   BASEMENT: "stairs",
   STORAGE: "package",
   ATTIC: "roof",
   BATHROOM: "bath",
   BATHROOM_WITH_TOILET: "bath",
   TOILET: "toilet",
   POOL: "pool",
   SAUNA: "steam",
   WINTER_GARDEN: "snowflake",
   OTHER: "squares",
};
